// material ui
import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon';

// Tabler icon "moon" - used for the evening greeting.
export default function MoonIcon(props: SvgIconProps) {
  return (
    <SvgIcon
      {...props}
      viewBox="0 0 24 24"
      sx={{ fill: 'none', stroke: 'currentColor', ...props.sx }}
    >
      <path
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 3c.132 0 .263 0 .393 0a7.5 7.5 0 0 0 7.92 12.446a9 9 0 1 1 -8.313 -12.454l0 .008"
      />
    </SvgIcon>
  );
}
